import type { PropsWithChildren } from 'react'
import Iconify from '@c/icon/iconify'
import icon360 from '@i/global/360浏览器icon.jpg'
import guard from '@i/global/guard.svg'

const BrowserLayout = (props: PropsWithChildren) => {
  const info = detect()
  useEffect(() => {
    jLogOnce('浏览器信息', info)
  }, [])

  const isSupport = useCallback(() => {
    if (info?.name === 'chrome' && Number(info.version.split('.')[0]) < 91) return false
    if (info?.name === 'edge-chromium' && Number(info.version.split('.')[0]) < 91) return false
    if (info?.name === 'firefox' && Number(info.version.split('.')[0]) < 78) return false
    return true
  }, [info])

  if (isSupport()) {
    return <>{props.children}</>
  }

  return (
    <div className="h-screen w-screen fccc">
      <img alt="guard" className="mb-4 max-h-50vh" src={guard} />
      <h3>
        为保障信息安全以及内容正常显示，推荐下载使用现代浏览器（如
        <a href="https://www.google.com/chrome/" rel="noreferrer" target="_blank">
          <Iconify icon="logos:chrome" /> Chrome
        </a>
        、
        <a href="https://www.microsoft.com/zh-CN/edge/download" rel="noreferrer" target="_blank">
          <Iconify icon="logos:microsoft-edge" /> Edge
        </a>
        、
        <a href="https://www.mozilla.org/zh-CN/firefox/new/" rel="noreferrer" target="_blank">
          <Iconify icon="logos:firefox" /> FireFox
        </a>
        、
        <a href="https://browser.360.cn/se/" rel="noreferrer" target="_blank">
          <span className="anticon" role="img">
            <img className="w-1.1em" src={icon360} />
          </span>
          360安全浏览器
        </a>
        等）
      </h3>
    </div>
  )
}

export default BrowserLayout
